// Tons sémantiques des pastilles de la carte lead auto : un ton par
// signification, le même sur la carte, la barre d'accès et le panneau.
export const TONS = ["neutre", "info", "ok", "attention", "danger"];

// État de l'agent de tarification (graal : agent.etat) → ton de pastille.
const TON_PAR_ETAT_AGENT = {
  en_file: "neutre",
  en_cours: "info",
  attente_action: "attention",
  termine: "ok",
  echec: "danger",
};

export const tonEtatAgent = (etat) => TON_PAR_ETAT_AGENT[etat] || "neutre";
